import * as R from 'ramda';
import { useLocation } from "react-router-dom";

import { Logo } from "../../components";
import { Flex } from "../../style";
import { sizes } from "../../variables";
import MobileMenu from "../Menu";
import { NavbarItem } from "./components/NavbarItem";
import { ITEMS } from "./constants";
import { Container } from "./style";


const DesktopMenu = () => {
  return (
    <Flex gap={sizes.lg} alignItems="center" className="desktop-menu">
      {ITEMS.map(({ path, title }, index) => {
        const key = `navbar-item-${index}`;
        return (
          <NavbarItem to={path} key={key}>
            {title}
          </NavbarItem>
        );
      })}
    </Flex>
  );
};

const Navbar = () => {
  const { pathname } = useLocation();

  const shouldShow = () => {
    const fullPages = ['/wall/empty', '/404', '/empty-wall/'];
    const match = fullPages.find(page => pathname.includes(page));
    return R.isEmpty(match) || R.isNil(match);
  };
  return (
    <Container show={shouldShow()}>
      <Logo />
      <DesktopMenu />
      <MobileMenu />
    </Container>
  );
};

export default Navbar;
